import competitionCRUDActions from '../actions/competition'

import BaseCRUDReducer from './CRUDReducer'

const CRUDReducer = new BaseCRUDReducer(competitionCRUDActions)

export default (state, action) => CRUDReducer.run(state, action)



// WEBPACK FOOTER //
// ./src/reducers/competition.js